import ExoDialog from '../../exo/ExoDialog';
import { useState } from 'react';
import LabeledBox from '../../special/LabeledBox';
import { MatchingPropertiesList } from '../../exo/matching-properties/MatchingPropertiesList';
import { MatchingPropertieShow } from '../../exo/matching-properties/MatchingPropertieShow';
import { Box, Button } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useTranslation } from 'react-i18next';
import { updateOrCreate } from '../../special/updateOrCreate';

export const TypeSalesObjectProperties = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
  size,
  onFocus,
  onBlur,
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  function handleChangedSelection(selection) {
    updateValidationOnChange([field.key], selection);
    setOpen(false);
  }

  function handlePropChange(data) {
    const newProps = updateOrCreate(dataCollection[field.key], data.data);
    handleChangedSelection(newProps);
  }

  const properties = dataCollection[field.key];

  return (
    <>
      <LabeledBox label={field.label} className="flex flex-col gap-2">
        {properties?.map((property) => (
          <MatchingPropertieShow
            key={property.id}
            property={property}
            isEditMode
            onChange={handlePropChange}
            isLead
          />
        ))}
        <Box className="pt-2">
          <Button
            className="flex items-center gap-4"
            color="secondary"
            onClick={() => setOpen(true)}
            sx={{
              paddingLeft: '5px',
            }}
          >
            <AddCircleIcon color="success" />
            {field.addLabel || t('Add')}
          </Button>
        </Box>
      </LabeledBox>
      <ExoDialog open={open} onClose={() => setOpen(false)}>
        <MatchingPropertiesList
          onSelectionChange={handleChangedSelection}
          properties={dataCollection[field.key]}
          isLead
          onClose={() => setOpen(false)}
        />
      </ExoDialog>
    </>
  );
};
